export default "__VITE_ASSET__OvXTTDSE__"